import React, { useEffect } from 'react'
import { Grid, Link } from '@mui/material'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { object, string } from 'yup'

import { FadeInWrapper, PageTitle } from '../../components'
import {
  Form,
  FormSchema,
  FormSchemaMessages,
  FormSchemaTests,
  SubmitButton,
  SubmitErrorMessage,
  TextFieldControl,
} from '../../components/form'
import { APP_ROUTES } from '../../constants.ts'
import { useLoginMutation } from '../../services'
import { useAppDispatch } from '@/stores/hooks.ts'
import { userActions } from '@/stores/slices/user-slice.ts'

export interface LoginFormProps {
  handleNextStage(): void
}

interface LoginFormState {
  login: string
  password: string
}

const loginFormSchema = object<FormSchema<LoginFormState>>({
  login: string().required(FormSchemaMessages.required).test(FormSchemaTests.isEmail),
  password: string().required(FormSchemaMessages.required),
})

export const LoginForm = ({ handleNextStage }: LoginFormProps): React.ReactElement => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { mutateAsync, isError, error, isSuccess, data } = useLoginMutation()

  const handleLoginMutation = async (form: LoginFormState) => {
    try {
      await mutateAsync(form)
      dispatch(userActions.setLogin(form.login))
    } catch (e) {
      // используем mutateAsync чтобы отображался лоадер на кнопке
    }
  }

  useEffect(() => {
    if (isSuccess) {
      if (data?.data.isChangePassword) {
        navigate(APP_ROUTES.ChangePassword)
      } else {
        handleNextStage()
      }
    }
  }, [isSuccess])

  useEffect(() => {
    if (isError) {
      dispatch(userActions.setLogin(''))
    }
  }, [isError])

  return (
    <FadeInWrapper>
      <PageTitle title="Личный кабинет СБП юридического лица" />
      <Form<LoginFormState> name="login" validationSchema={loginFormSchema} onSubmit={handleLoginMutation}>
        <Grid item container flexDirection="column" spacing={2}>
          <Grid item xs={12}>
            <TextFieldControl<LoginFormState> name="login" label="Ваш email" fullWidth type="email" />
          </Grid>
          <Grid item xs={12}>
            <TextFieldControl<LoginFormState>
              name="password"
              label="Пароль"
              autoComplete="off"
              fullWidth
              type="password"
              helperText={
                <Link component={RouterLink} to={APP_ROUTES.Restore}>
                  Забыли пароль?
                </Link>
              }
            />
          </Grid>
        </Grid>
        <Grid item sx={{ mt: { xs: 4, lg: 6 } }}>
          <SubmitErrorMessage isError={isError} message={error?.response?.data?.errorMessage} />
          <SubmitButton>Войти</SubmitButton>
        </Grid>
      </Form>
    </FadeInWrapper>
  )
}
